import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";
import { Star } from "lucide-react";
import { TESTIMONIALS } from "../../data/site";

const ease = [0.22, 1, 0.36, 1];

const Card = ({ t }) => (
  <div className="mx-3 flex w-[320px] shrink-0 flex-col rounded-[1.75rem] border border-white/10 bg-white/[0.03] p-7 backdrop-blur-2xl md:w-[380px]">
    <div className="flex gap-1 text-[#ffb7b2]">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-current" />
      ))}
    </div>
    <h3 className="mt-5 font-display text-lg font-medium text-white">
      {t.title}
    </h3>
    <p className="mt-3 flex-1 text-sm leading-relaxed text-white/55">
      {t.body}
    </p>
    <p className="mt-6 text-xs uppercase tracking-[0.2em] text-white/40">
      — {t.name}
    </p>
  </div>
);

export const Testimonials = () => (
  <section
    id="reviews"
    className="relative z-10 py-24 md:py-32"
    data-testid="testimonials-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.9, ease }}
      className="mx-auto mb-16 max-w-7xl px-6 md:mb-20 md:px-10"
    >
      <p className="mb-6 text-xs font-semibold uppercase tracking-[0.35em] text-white/40">
        Member feedback
      </p>
      <h2 className="max-w-2xl font-display text-4xl font-extralight leading-tight tracking-tight text-white md:text-6xl">
        What our members are{" "}
        <span className="italic text-white/70">saying.</span>
      </h2>
    </motion.div>

    <Marquee speed={30} gradient={false} pauseOnHover autoFill>
      {TESTIMONIALS.map((t, i) => (
        <Card key={i} t={t} />
      ))}
    </Marquee>
  </section>
);
